import { render, staticRenderFns } from "./ContestPage.vue?vue&type=template&id=02421614&scoped=true&"
import script from "./ContestPage.vue?vue&type=script&lang=js&"
export * from "./ContestPage.vue?vue&type=script&lang=js&"
import style0 from "./ContestPage.vue?vue&type=style&index=0&id=02421614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02421614",
  null
  
)

export default component.exports